import { config } from "@/config";

/**
 * Builds a complete image URL from a relative path, using CDN if configured.
 * Falls back to local path if CDN is not available.
 *
 * @param relativePath - Relative image path (e.g., 'images/servicingv2/slide-crop-1.png')
 * @returns Complete image URL
 *
 * @example
 * buildImageUrl('images/servicingv2/slide-crop-1.png')
 * // Production: 'https://cdn.freedommortgage.com/content/prod/images/servicingv2/slide-crop-1.png'
 * // Local: '/images/servicingv2/slide-crop-1.png'
 */
export function buildImageUrl(relativePath: string): string {
  const cdnRootUrl = config.env("cdnRootUrl");

  if (cdnRootUrl) {
    return `${cdnRootUrl}/${relativePath}`;
  }

  return `${import.meta.env.BASE_URL}${relativePath}`;
}
